import {http_client} from "@/plugins/http_client";
const BASE_EXTERNAL = process.env.VUE_APP_AUTH_BASE_URL;

/**
 * Realiza una solicitud HTTP al cliente externo.
 * @param {string} url - La URL del endpoint.
 * @param {Object} data - Los datos a enviar en la solicitud.
 * @param {string} method - El método HTTP (get, post, put, delete).
 * @param {Object} headers - Los encabezados personalizados para la solicitud.
 * @param {boolean} sendToken - Indica si se debe enviar el token de autenticación.
 * @param {string} responseType - El tipo de respuesta esperada (json, blob, etc.).
 * @returns {Promise} - Una promesa que resuelve la respuesta de la solicitud.
 */
export const externalClient = (url, data = {}, method = 'get', headers = {}, sendToken = true, responseType = 'json') => {
  return http_client(url, data, method, headers, sendToken, responseType, BASE_EXTERNAL);
};

//municipios y departamentos
const getEstablecimientos = async (params = {}) => await externalClient('/api/v1/instituciones/establecimiento', params)
const getDepartamentos = async (filtros) => await externalClient('/api/v1/catalogos/departamentos', filtros, "get")
const getMunicipios = async (filtros = {}) => await externalClient(`/api/v1/catalogos/municipios`, filtros, "get")
const getTiposHorario = async (filtros = {}) => await externalClient(`/api/v1/catalogos/tipo-horario`, filtros, "get")
const getJornadas = async (filtros = {}) => await externalClient(`/api/v1/catalogos/tipo-horario`, filtros, "get")
const getHorarios = async (filtros = {}) => await externalClient(`/api/v1/jornadas`, filtros, "get")
const getInstituciones = async (params = {}) => await externalClient(`/api/v1/catalogos/instituciones`, params)

// create, edit, delete
const createEstablecimiento = async (body) => await externalClient(`/api/v1/instituciones/establecimiento`, body, 'post')
const editEstablecimiento = async (id, body) => await externalClient(`/api/v1/instituciones/establecimiento/${id}`, body, 'put')
const deleteEstablecimiento = async (id) => await externalClient(`/api/v1/instituciones/establecimiento/${id}`, {}, "delete");

export default {
    getEstablecimientos,
    getDepartamentos,
    getMunicipios,
    getTiposHorario,
    getJornadas,
    getHorarios,
    createEstablecimiento,
    editEstablecimiento,
    deleteEstablecimiento,
    getInstituciones,
}
